export default __webpack_public_path__ + "static/media/submit-service-en.b1247141.png";